import { CONFIG } from "@/config";
import { Mail, Phone, Calendar, MapPin, ArrowUpRight } from "lucide-react";

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="border-b border-[#EAEAEA] bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-6">
          <div className="overline">Begin</div>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight font-medium mt-4 leading-[1.05]">
            Enquire about a tutoring session or consultation.
          </h2>
          <p className="mt-6 text-[#4A4A52] leading-relaxed max-w-md">
            Every engagement starts with a short, no-obligation conversation about your
            child — where they&apos;re at, what their goals are, and the kind of tutoring
            or consulting support that would help most. Call or email any time.
          </p>
        </div>

        <div className="lg:col-span-6 lg:pt-24">
          <ul className="space-y-8">
            <li className="flex items-start gap-4" data-testid="contact-phone-item">
              <Phone size={18} className="text-[#0A192F] mt-1" />
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#4A4A52]">Mobile</div>
                <a
                  href={`tel:${CONFIG.contactPhone.replace(/\s/g, "")}`}
                  className="font-display text-lg md:text-xl font-medium text-[#0A0A0B] hover:text-[#0A192F] transition-colors"
                  data-testid="contact-phone-link"
                >
                  {CONFIG.contactPhone}
                </a>
              </div>
            </li>
            <li className="flex items-start gap-4" data-testid="contact-email-item">
              <Mail size={18} className="text-[#0A192F] mt-1" />
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#4A4A52]">Email</div>
                <a
                  href={`mailto:${CONFIG.contactEmail}`}
                  className="font-display text-lg md:text-xl font-medium text-[#0A0A0B] hover:text-[#0A192F] transition-colors break-all"
                  data-testid="contact-email-link"
                >
                  {CONFIG.contactEmail}
                </a>
              </div>
            </li>
            <li className="flex items-start gap-4" data-testid="contact-location-item">
              <MapPin size={18} className="text-[#0A192F] mt-1" />
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#4A4A52]">Availability</div>
                <div className="font-display text-lg md:text-xl font-medium text-[#0A0A0B]">
                  {CONFIG.location}
                </div>
              </div>
            </li>
          </ul>

          <a
            href={`mailto:${CONFIG.contactEmail}?subject=Tutoring enquiry`}
            data-testid="contact-email-cta"
            className="group mt-10 inline-flex items-center gap-2 bg-[#0A192F] hover:bg-[#172A4A] text-white text-sm font-semibold tracking-wide px-7 py-4 transition-all hover:-translate-y-0.5"
          >
            Email Claire
            <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
    </section>
  );
};
